export default class AlwaysRefreshStrategy {

    wouldRefresh(/* ads */) {
        return true;
    }

}
